module.exports = __webpack_public_path__ + "static/media/middle-none-2.f2ebb4f2.png";